const { createDate, vehicleReqDate, routeShortForm, routeDetails } = require('../../utils');

module.exports = [
  {
    id: 1,
    key: 'indent_id',
    label: 'INDENT ID',
    css_class: 'order-id',
    data: {
      key: 'order_number',
    },
    truncate_on: 20,
    dependency: {
      is_enabled: true,
      css_class: 'test',
      data: {
        key: 'created_at',
        view_rule: date => createDate(date),
      },
      truncate_on: 20,
    },
  },
  {
    id: 2,
    label: 'STATUS',
    css_class: 'order-status',
    data: {
      key: 'status',
    },
    truncate_on: 20,
  },
  {
    id: 3,
    label: 'ROUTE',
    css_class: 'order-route',
    data: {
      key: 'route_location',
      view_rule: routeLocation => routeShortForm(routeLocation),
    },
    expanded_text: {
      data: {
        key: 'route_location',
        view_rule: routeLocation => routeDetails(routeLocation),
      },
    },
    truncate_on: 20,
    dependency: {
      is_enabled: true,
      css_class: 'test',
      data: {
        key: 'destinations',
        view_rule: destinations => (destinations[0].details && destinations[0].details.name) || '-',
      },
      truncate_on: 20,
    },
  },
  {
    id: 4,
    label: 'CARRIER',
    css_class: 'order-vendor',
    data: {
      key: 'transporter_name',
    },
    truncate_on: 16,
    dependency: {
      is_enabled: true,
      css_class: '',
      data: {
        key: 'ship_pack_details',
        view_rule: shipPackDetails => (shipPackDetails && shipPackDetails.method) || '-',
      },
      truncate_on: 20,
    },
  },
  {
    id: 5,
    label: 'SHIPPING DATE',
    css_class: 'order-shipment',
    data: {
      key: 'sources',
      view_rule: sources => vehicleReqDate(sources),
    },
    truncate_on: 16,
  },
  {
    id: 6,
    label: 'DELIVERY ID',
    css_class: 'order-shipment',
    data: {
      key: 'deliveries',
      view_rule: deliveryNumbers => (deliveryNumbers.length ? deliveryNumbers.toString() : '-'),
    },
    truncate_on: 20,
  },
];
